import { render } from "./GiftCampaignTriggerRow.vue?vue&type=template&id=e8c57e2c&scoped=true"
import script from "./GiftCampaignTriggerRow.vue?vue&type=script&lang=js"
export * from "./GiftCampaignTriggerRow.vue?vue&type=script&lang=js"

import "./GiftCampaignTriggerRow.vue?vue&type=style&index=0&id=e8c57e2c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c57e2c"]])

export default __exports__